module.exports = {"elasticsearchHost":"wma-elasticsearch.prod.flightstats.io:9200","billingHost":"https://wma-k8s.pdx.prod.flightstats.io/wma-billing/api","flightAlertsHost":"https://wma-k8s.pdx.prod.flightstats.io/wma-flight-alerts/api","dataExportsHost":"https://wma-k8s.pdx.prod.flightstats.io/wma-data-exports/api","GAID":"UA-382334-26","GAGOID":"GTM-MFW3PHQ","usersHost":"https://users.pdx.prod.flightstats.io","sentry":"https://845707f0e2a7460fbecebedf88a01180:2522cadea55b42bf97ae9d0dff7b0870@sentry.io/148035","redisHost":"wma-web-prod.zr0lbm.ng.0001.usw2.cache.amazonaws.com","redisPort":6379}


//////////////////
// WEBPACK FOOTER
// ./config/config-production.json
// module id = 3122
// module chunks = 1